import api from "./api";

// Fetch all terms and policies
export const fetchAllPolicies = async () => {
  try {
    const response = await api.get('/terms-and-policies-management/policies/');
    if (response.status === 200) {
      return response.data; 
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error fetching policies:", error.message || error);
    return { error: error.response?.data?.detail || error.message || "Failed to fetch policies" };
  }
};

// Create a new policy
export const createPolicy = async (policyData) => {
  try {
    const response = await api.post('/terms-and-policies-management/policies/', policyData);
    if (response.status === 200) {
      return response.data;
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error creating policy:", error.message || error);
    return { error: error.response?.data?.detail || error.message || "Failed to create policy" };
  }
};

// Update a specific policy
export const updatePolicy = async (policyId, policyData) => {
  try {
    const response = await api.put(`/terms-and-policies-management/policies/${policyId}`, policyData);
    if (response.status === 200) {
      return response.data;
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error updating policy:", error.message || error);
    return { error: error.response?.data?.detail || error.message || "Failed to update policy" };
  }
};

// Delete a specific policy
export const deletePolicy = async (policyId) => {
  try {
    const response = await api.delete(`/terms-and-policies-management/policies/${policyId}`);
    if (response.status === 200) {
      return response.data; 
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error deleting policy:", error.message || error);
    return { error: error.response?.data?.detail || error.message || "Failed to delete policy" };
  }
};
